import $ from 'jquery';

const mainWrapper = $('.profile-body');
const profile_trigger = $('.profile-nav__title');
const profile_nav = $('.profile-nav');

document.title = 'Кабінет';

$(document).ready(function () {
  calendarEvent();
  progressBar();
  faqSection();
  feedbackForm();
  datePickerHelper();
  changePassword();
  untieExpert();

  $('.profile-nav ul a').click(function (e) {
    const parent = $(this).closest('li');
    const linkMenu = $(this).attr('href');
    const linkAttr = $(this).attr('history');
    const titleMenu = $(this).text();
    const attr = $(this).attr('data-cv');
    const postForm = $(this).attr('data-post');

    $('.profile-nav ul li').removeClass('active');
    parent.addClass('active');

    window.location.replace(`${themeVars['home']}/profile/${linkMenu}`);

    document.title = titleMenu;

    if (!(typeof attr !== 'undefined' && attr !== false)) {
      e.preventDefault();
    }

    ajaxProfile(linkMenu, linkAttr, postForm);
    linkHelper(linkMenu);
  });

  function ajaxProfile(linkMenu,postForm) {
    mainWrapper.animate({opacity: 1}, 1000, "linear");

    mainWrapper.attr('data-tax', linkMenu.slice(1, linkMenu.length))

    const urlReplace = linkMenu.replace(/-/g, "_").substring(1);
    let data;

    data = {
      action: urlReplace,
      postForm: postForm,
    }

    $.post(themeVars['ajax_url'], data, function (response) {
      mainWrapper.empty();

      /*eslint-disable */
      acf.do_action('append', mainWrapper.append(response));
      /*eslint-enable */

      $('.acf-basic-uploader input').attr('required', 'required')

      $('.close-request').click(function (e) {
        e.preventDefault();
        let answerForm = $(this);
        let postId = answerForm.closest('.history-requests').attr('value');
        data = {
          action: 'close_request',
          postId: postId,
        }
        $.post(themeVars['ajax_url'], data, function () {
          answerForm.parent('.comment-form__body').closest('.form-wrapper').css('display', 'none');
          answerForm.closest('.history-requests').find('.open-request').css('display', 'block');
          answerForm.closest('.history-requests').find('.answers-status').text('Завершено').addClass('answers-status_close');
        });

      });

      $('.untie-profile').click(function (e) {
        e.preventDefault();
        let answerForm = $(this);
        let userEmail = $(this).attr("data-email");
        let postId = answerForm.closest('.history-requests').attr('value');
        data = {
          action: 'untie_profile',
          postId: postId,
          userEmail: userEmail,
        }
        $.post(themeVars['ajax_url'], data, function () {
          answerForm.closest('.history-requests').css('display', 'none');
        });

      });

      $('.open-request').click(function () {
        let answerForm = $(this);
        let postId = answerForm.closest('.history-requests').attr('value');

        data = {
          action: 'open_request',
          postId: postId,
        }
        $.post(themeVars['ajax_url'], data, function () {
          answerForm.css('display', 'none');
          answerForm.next('.form-wrapper').css('display', 'block');
        });
      });

      inputFileCheker($('input[type="file"]'))

      $('.comment-form__body').submit(function (e) {
        e.preventDefault()

        let commentForm = $(this);
        let file = $('.comment-form__body').find('input[type="file"]');
        let formDatePicker = commentForm.find('.submit-picker');
        let commentData = commentForm.serializeArray();

        let fd = new FormData();


        fd.append("file", file[0]?.files[0]);
        fd.append("caption", 'form_file');
        fd.append('action', 'send_answer');
        fd.append('datePicker', formDatePicker.val());
        fd.append('name', commentForm.data('name'));
        fd.append('secondName', commentForm.data('second'));
        fd.append('comment', commentData[0]['value']);
        fd.append('comment_post_ID', commentData[1]['value']);
        fd.append('comment_parent', commentData[2]['value']);
        fd.append('lstc_subscribe', commentData[3]['value']);


        $.ajax({
          type: 'POST',
          url: themeVars['ajax_url'],
          data: fd,
          processData: false,
          contentType: false,

          error: function (request, status) {

            if (status === 500) {
              alert('comment add error');
            } else if (status === 'timeout') {
              alert('server error');
            }

          },
          success: function (newComment) {
            console.log(newComment)
            if (newComment['success'] === 'true') {
              let date = newComment.date_picker?.length > 0 ? `<p class="comment-data">Дата: ${newComment.date_picker}</p>` : '';
              let fileLink = newComment.fileUrl?.length > 0 ? `<a href="${newComment.fileUrl}"
                target="_blank">Відкрити резюме</a>` : '';
              formDatePicker.val('')
              file.val('')

              commentForm.parent('.form-wrapper').siblings('.comment-list').append(`
                            <div class="answers__history" id="comment-${newComment.comment_id}">
                                <div class="answer__title">
                                    <h5 class="comment-author"><span>${newComment.name}</span>
                                    <span>${newComment.secondName}</span></h5>
                                    <p class="comment-date">${newComment.date?.split(" ")[0]}</p>
                                    <p class="comment-time">${newComment.date?.split(" ")[1]}</p>
                                </div>
                                ${date}
                                <div class="comment-question">${newComment.comment_content}
                                ${fileLink}</div>
                            </div>
                        `);
              $('#commentform textarea').val('');

              commentForm.closest('.history-requests').find('.answers-status').text('Немає відповіді').addClass('answers-status_no-answer').parent().removeClass('has-answer')

            }
          },

        });

        return false;
      });

      $('.psy-request__btn').click(function (e) {
        e.preventDefault();
        let postId = $(this).attr('data-post');
        let authorId = $(this).attr('data-author');
        let userMeta = $(this).attr('data-meta')

        data = {
          action: 'take_request',
          postId: postId,
          authorId: authorId,
          userMeta: userMeta,
        }

        $.post(themeVars['ajax_url'], data, function (data) {
          mainWrapper.empty();
          mainWrapper.append(data);
          setTimeout(() => {
            let hash = window.location.hash;
            switch (hash) {
              case '#all-online-request':
                $(document).ready(function () {
                  $(`.profile-nav a[href="#responsible-online-request"]`)[0].click(openMsg(postId));
                });
                break;
              case '#all-psy-request':
                $(document).ready(function () {
                  $(`.profile-nav a[href="#responsible-psy-request"]`)[0].click(openMsg(postId));
                });
                break;
              case '#all-interview-request':
                $(document).ready(function () {
                  $(`.profile-nav a[href="#responsible-interview-request"]`)[0].click(openMsg(postId));
                });
                break;
              case '#all-resume-request':
                $(document).ready(function () {
                  $(`.profile-nav a[href="#responsible-resume-request"]`)[0].click(openMsg(postId));
                });
                break;
            }
          }, 1000)
        });

        return false;
      });
      $('html, body').animate({scrollTop: 0}, 0);
      removeBlock();
      answerOrder();
    });
  }
});

function linkHelper(linkMenu) {
  if (linkMenu === '#create-career-request') {
    $(document).click(function () {
      $('.acf-taxonomy-field').find('span:contains("Послуги кар’єрного консультанта")').prev('input').prop('checked', true);
    });
  } else if (linkMenu === '#create-online-request') {
    $(document).click(function () {
      $('.acf-taxonomy-field').find('span:contains("Запит на онлайн консультацію")').prev('input').prop('checked', true);
    });
  } else if (linkMenu === '#create-psy-request') {
    $(document).click(function () {
      $('.acf-taxonomy-field').find('span:contains("Послуги психолога")').prev('input').prop('checked', true);
    });
  } else if (linkMenu === '#create-resume-request') {
    $(document).click(function () {
      $('.acf-taxonomy-field').find('span:contains("Перевірка резюме")').prev('input').prop('checked', true);
    });
  } else if (linkMenu === '#create-interview-request') {
    $(document).click(function () {
      $('.acf-taxonomy-field').find('span:contains("Тестова співбесіда")').prev('input').prop('checked', true);
    });
  }
}

function datePickerHelper() {
  /*eslint-disable */
  acf.add_filter('date_picker_args', function (args, $field) {
    args['minDate'] = '0';
    args['maxDate'] = '60';

    return args;
  });
  /*eslint-enable */
}

function feedbackForm() {
  const feedback_trigger = $('.feedback')
  const feedback_container = $('.feedback-form')
  const feedback_form = $('.feedback-form__form')
  const feedback_close = $('.feedback-trigger')
  let focusedeElementBeforeOpen;

  profile_trigger.click(function () {
    profile_nav.toggleClass('profile-nav_active')
  })

  $(document).on("click", '.answers-info', function () {
    $(this).siblings().fadeToggle();
    $(this).toggleClass('active');
  });

  feedback_trigger.click(function () {
    feedback_container.fadeIn()
    feedback_form.addClass('form_active')

    focusedeElementBeforeOpen = document.activeElement;
    let focusableElementsString = 'button:not([disabled]), select:not([disabled]), textarea:not([disabled]), input:not([type=hidden])';
    let focusableElements = feedback_form.find(focusableElementsString);
    focusableElements = Array.prototype.slice.call(focusableElements);

    let firstTabStop = focusableElements[0];
    let lastTapStop = focusableElements[focusableElements.length - 1];

    firstTabStop.focus();

    function trapTabKey(e) {
      if (e.keyCode === 9) {
        if (e.shiftKey) {
          if (document.activeElement === firstTabStop) {
            e.preventDefault()
            lastTapStop.focus();
          }
        } else {
          if (document.activeElement === lastTapStop) {
            e.preventDefault()
            firstTabStop.focus()
          }
        }
      }

      if (e.keyCode === 27) {
        feedback_close.click(function () {
          feedback_container.fadeOut()
          feedback_form.removeClass('form_active')
        })
      }
    }

    document.addEventListener('keydown', trapTabKey)
  })

  feedback_close.click(function () {
    feedback_container.fadeOut()
    feedback_form.removeClass('form_active')
    focusedeElementBeforeOpen.focus()
  })

  $(document).click(function (e) {
    if (e.target.closest('.feedback-form__form') === null && e.target.closest('.feedback') === null) {
      feedback_container.fadeOut()
      feedback_form.removeClass('form_active')
    }
  })
}

function faqSection() {
  let accordionBlock = $('.accordion-block__question');
  $(document).on('click', '.accordion-block__question', function () {
    accordionBlock.not(this).parent().removeClass('accordion-block__repeater_active')
    $(this).parent().toggleClass('accordion-block__repeater_active')
    accordionBlock.not(this).next().slideUp()
    $(this).next().slideToggle('slow')
  });
}

function progressBar() {

  const inputs = $('.intro input')
  const inputs_all = inputs.length

  inputs.each(function () {

    if ($(this).val() === '0' || $(this).val().length === 0) {
      $(this).parent().hide()
    } else {
      $(this).addClass('progress-item')
    }
  })

  const inputs_filled = $('.progress-item').length
  const progress = Math.ceil(100 * inputs_filled / inputs_all)
  const progress_field = $('.progress__number')
  const progress_circle = $('.progress__percent svg circle:nth-child(2)')
  const progress_info = $('.progress-info')
  const profile_info = $('.profile[data-profile]')


  profile_info.attr("data-profile", progress);
  progress_field.text(progress + '%')
  progress_circle.css("--percent", progress);

  if (progress >= 50) {
    progress_info.text('Вам надано повний доступ')
  } else {
    progress_info.text('Для отримання повного доступу заповніть дані профіля мінімум на 50%')
  }
}

function calendarEvent() {
  const has_event = $('.has-event');

  has_event.each(function () {
    $(this).children('a').wrapAll($('<div/>', {'class': 'calendar-events'}));
  });

  $('.calendar-events').prepend('<div class="calendar-events__trigger"></div>');
  $('.calendar-events').hide();

  has_event.click(function () {
    $('.has-event').not(this).find('.calendar-events').slideUp()
    $(this).find('.calendar-events').slideToggle()
  })

  $(document).click(function (e) {
    if (e.target.closest('.has-event') === null && e.target.closest('.calendar-events__trigger') === null) {
      $('.calendar-events').slideUp()
    }
  })
}

function removeBlock() {
  if ($('.profile').attr("data-profile") >= 50) {
    $('.form-container').removeClass('blocked');
  }
}

function changePassword() {
  let getEmail = $('form.intro').find('input[name="email"]').val();
  $('.somfrp-lost-pass-form-text p').text('Змінити пароль');
  $('#reset-pass-submit').text('Надіслати пароль');
  $('#somfrp_user_info').prop('readonly', true);
  $('#somfrp_user_info').val(getEmail);
}

function answerOrder() {
  let historyItem = $('.answers-status_has-answer')

  historyItem.each(function () {
    $(this).closest('.history-requests').addClass('has-answer')
  })
}

function untieExpert() {
  $(document).on("click", '.untie-user', function (e) {
    e.stopPropagation();
    let authorId = $(this).attr('data-untie');
    let userMeta = $(this).attr('data-meta');
    let hash = window.location.hash;

    let data = {
      action: 'untie_expert',
      authorId: authorId,
      userMeta: userMeta,
    }


    $.post(themeVars['ajax_url'], data, function () {
      $('.profile-info').addClass('load');
      $(`.profile-nav a[href="${hash}"]`)[0].click();
      setTimeout(() => {
        $('.profile-info').removeClass('load');
      }, 2000)
    });
  });
}

function openMsg(attr) {
  setTimeout(() => {
    const el = $(`[value=${attr}]`).find('.answers-info')[0];
    const scrollTo = $(`[value=${attr}]`).find('.answers-info');
    if (scrollTo.length) {
      el.click();
      $([document.documentElement, document.body]).animate({
        scrollTop: scrollTo.offset().top,
      }, 1000);
    }
  }, 1500);
}

function inputFileCheker(input) {
  input.on('change', function () {
    let myfile = $(this).val();
    let ext = myfile.split('.').pop();
    if (!(ext === "pdf" || ext === "docx" || ext === "doc" || ext === "jpeg" || ext === "jpg" || ext === "png")) {
      alert('Файл повинен мати розширення pdf, docx, doc, jpeg, png');
      $(this).val('');
    }

    if (input[0]?.files[0]?.size > 10000000) {
      alert("Файл не повинен бути більше 10MB");
      alert(input[0]?.files[0]?.size);
      $(this).val('');
    }
  });
}

jQuery(function () {
  $(document).click(function () {
    const dateToday = new Date();
    jQuery('.submit-picker').datepicker({
      dateFormat: 'dd MM yy',
      minDate: dateToday,
    }).val();
  })
});

// second submit logic

$(document).on('submit','.form-container form.acf-form', function (e) { 
  let mainForm = $('.form-container form');
  let commentContent = $('.acf-field-textarea .acf-input textarea').val();
  let commentTheme = $('#acf-_post_title').val();
  let postId = $('.form-container').attr("data-post");
  let fileUrl = $('.acf-file-uploader').find('input[type="file"]');
  let formDatePicker = $('.acf-date-picker').find('input.hasDatepicker').val();

  let fd = new FormData();

  fd.append('action', 'send_answer');
  fd.append('comment', commentContent);
  fd.append('commentTheme', commentTheme);
  fd.append('comment_post_ID', postId);
  if (fileUrl[0]) {
    fd.append('file', fileUrl[0]?.files[0]);
  }
  if (formDatePicker) {
    fd.append('datePicker', formDatePicker);
  }

  if (postId) {
    e.preventDefault();

    if (fileUrl[0]) {
      inputFileCheker($('.acf-file-uploader input[type="file"]'))
    }

    $.ajax({
      type: 'POST',
      url: themeVars['ajax_url'],
      data: fd,
      processData: false,
      contentType: false,
  
      error: function (request, status) {
  
        if (status === 500) {
          alert('comment add error');
        } else if (status === 'timeout') {
          alert('server error');
        }
  
      },
      
      success: function (newComment) {
        if(newComment.success === "true") {
          console.log(newComment);
          window.location.href = `${themeVars['home']}/thank-you-msg`;
          mainForm[0].reset();
        }
      },
    });
  } else  {
    return;
  }
  return false;
});